import React, { useContext } from 'react';
import { TenantConfig } from 'app/lib/TenantConfig';

const tenant = TenantConfig.getInstance();
export const AppContext = React.createContext(tenant);

export const useAppContext = () => {
  const context = useContext(AppContext);

  if (!context) {
    throw new Error('Missing AppContext.Provider in the tree!');
  }

  return context;
};
